export const style = {
    btn: "b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6",
    container: "ma2 mw5-l center bg-white",
    fieldContainer: "mt3",
    fieldInput: "b pa2 input-reset ba bg-transparent",
    fieldLabel: "db fw4 lh-copy f6",
};
